import { writable } from 'svelte/store';
// Create a store to keep track of feature flags.
export const flagsStore = writable(new Map());
// Function to update flagsStore
export function setFlags(flags) {
    if (!flags) {
        return;
    }
    try {
        const parsedFlags = JSON.parse(flags);
        flagsStore.set(new Map(Object.entries(parsedFlags)));
    }
    catch (e) {
        console.error('Error parsing flags', e);
    }
}
